import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门视频平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
            聚合多家优质视频平台，一站看遍全网热剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-2xl p-6 transition-all duration-300 hover:scale-[1.02] cursor-pointer overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 rounded-bl-full opacity-10 group-hover:opacity-20 transition-opacity duration-300"
                style={{ backgroundColor: 'oklch(var(--primary-500))' }}
              ></div>
              <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center mb-4`}>
                <i className={`${cat.icon} text-background-50 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap">
                浏览视频
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}